import WarningIcon from '@mui/icons-material/Warning';
import { Box, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { useTranslation } from 'react-i18next';

export type ExternalReferenceProps = {
    salaryProviderExternalReference?: string | null;
    timeRegistrationProviderExternalReference?: string | null;
};

export const ExternalReference = (props: ExternalReferenceProps) => {
    const { t } = useTranslation();
    return (
        <Box alignItems="center" display="flex">
            {props.salaryProviderExternalReference ==
                props.timeRegistrationProviderExternalReference && (
                <>{props.salaryProviderExternalReference}</>
            )}
            {props.salaryProviderExternalReference == null &&
                props.timeRegistrationProviderExternalReference && (
                    <>
                        <Tooltip title={t('time_regisration_external_ref')}>
                            <span>
                                {' '}
                                {
                                    props.timeRegistrationProviderExternalReference
                                }{' '}
                            </span>
                        </Tooltip>
                    </>
                )}
            {props.salaryProviderExternalReference &&
                props.timeRegistrationProviderExternalReference == null && (
                    <>
                        <Tooltip title={t('salary_provider_external_ref')}>
                            <span>
                                {' '}
                                {props.salaryProviderExternalReference}{' '}
                            </span>
                        </Tooltip>
                    </>
                )}
            {props.salaryProviderExternalReference !=
                props.timeRegistrationProviderExternalReference &&
                props.salaryProviderExternalReference &&
                props.timeRegistrationProviderExternalReference && (
                    <>
                        <Tooltip
                            title={`${t('salary_provider_external_ref')}/${t(
                                'time_regisration_external_ref'
                            )}`}
                        >
                            <span>
                                {' '}
                                {props.salaryProviderExternalReference} /{' '}
                                {
                                    props.timeRegistrationProviderExternalReference
                                }{' '}
                            </span>
                        </Tooltip>
                    </>
                )}
            {!props.salaryProviderExternalReference &&
                !props.timeRegistrationProviderExternalReference && (
                    <>
                        <Tooltip
                            style={{ display: 'flex', alignItems: 'center' }}
                            title={t('no_provider_external_ref')}
                        >
                            <span>
                                <InfoIcon />
                            </span>
                        </Tooltip>
                    </>
                )}
        </Box>
    );
};
